// simple hack to allow mocking window object

const windowCopy = window;

export { windowCopy as window };
